import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { DeferredRenderScheduler } from './FBDeferredRender.scheduler';

interface DeferredRenderContext {
  scheduler: DeferredRenderScheduler
}

const Context = createContext<DeferredRenderContext | undefined>(undefined);

export const FBDeferredRenderProvider: React.FC = ({ children }) => {
  const [scheduler] = useState(() => new DeferredRenderScheduler());
  const value = useMemo(() => ({ scheduler }), [scheduler]);
  useEffect(() => () => scheduler.dispose(), [scheduler]);
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useDeferredRender = (): DeferredRenderContext | undefined => useContext(Context);
